import type { ParentInboundMessage } from '../../protocol';

/** Guard for an inbound iframe→parent message, typed against
 * `ParentInboundMessage` from `src/protocol` (see docs/protocol.md). Validates
 * shape only; origin/source identity is the caller's responsibility
 * (`MessageRouter` — D1's trust-boundary check happens one layer up). */
export function isFromIframe(data: unknown): data is ParentInboundMessage {
  if (!data || typeof data !== 'object') {
    return false;
  }

  const message = data as Record<string, unknown>;

  if (message.type === 'card-ready') {
    return typeof message.card_reference_id === 'string';
  }

  if (message.type === 'card-error') {
    return typeof message.reason === 'string' || typeof message.code === 'string';
  }

  if (message.type === 'card-fields-valid') {
    return typeof message.valid === 'boolean';
  }

  if (message.type === 'content-resize') {
    return typeof message.height === 'number';
  }

  if (message.type === 'field-state') {
    return typeof message.field === 'string' && typeof message.valid === 'boolean';
  }

  if (message.type === 'group-ready') {
    return true;
  }

  if (message.type === 'field-input') {
    return typeof message.field === 'string';
  }

  if (message.type === 'field-focus') {
    return typeof message.field === 'string' && typeof message.focused === 'boolean';
  }

  return false;
}
